import { useTranslation } from "react-i18next";
import { getRelatedArticles } from "@/lib/blog";
import { ArticleCard } from "./ArticleCard";

interface RelatedArticlesProps {
  currentSlug: string;
  limit?: number;
}

export function RelatedArticles({ currentSlug, limit = 3 }: RelatedArticlesProps) {
  const { t } = useTranslation();
  const articles = getRelatedArticles(currentSlug, limit);
  if (articles.length === 0) return null;

  return (
    <section aria-labelledby="related-articles" style={{ marginTop: "var(--s-lg)" }}>
      <h3
        id="related-articles"
        style={{
          fontFamily: "\"Coolvetica\", system-ui, sans-serif",
          fontSize: "clamp(20px, 2.4vw, 28px)",
          textTransform: "uppercase",
          letterSpacing: "0.04em",
          color: "var(--dyna-fg)",
          margin: "0 0 var(--s-sm)",
        }}
      >
        {t("pages.blog.relatedArticles")}
      </h3>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
          gap: 20,
        }}
      >
        {articles.map((a) => (
          <ArticleCard key={a.frontmatter.slug} article={a} />
        ))}
      </div>
    </section>
  );
}
